export const containerStyle =
    "main-section p-0 d-flex justify-content-between align-items-center";

export const appStyles = "main bg-dark";
